import client from '@libs/HttpClient';
class EmpSepecificAttendenceReport {
  static listReport({ fromDate, toDate, employeeId }) {
    return client.get(
      `/report/private/employees-specific-attendence-report?from_date=${fromDate}&to_date=${toDate}&employee_id=${employeeId}`
    );
  } 
  static employeeListReport(request) {
    return client.get(
      `/report/private/all-employees`,
      request
    );
  }
  static inactiveEmployeeListReport(request) {
    return client.get(
      `/report/private/all-inactive-employees`,
      request
    );
  }
}
export { EmpSepecificAttendenceReport };